import React from 'react';
interface InvoiceFooterProps {
  paymentInstructions: {
    companyName: string;
    bankName: string;
    accountNo: string;
    paynowUen: string;
    notes: string[];
  };
}
export function InvoiceFooter({
  paymentInstructions
}: InvoiceFooterProps) {
  return <div className="pt-3 border-t border-neutral-200 mb-3" data-id="element-487">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3" data-id="element-488">
        <h3 className="text-xs font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-489">
          Payment Instructions
        </h3>

        <p className="text-xs text-neutral-900 mb-2" data-id="element-490">
          Please make payment to:{' '}
          <span className="font-semibold" data-id="element-491">
            {paymentInstructions.companyName}
          </span>
        </p>

        <div className="space-y-1 mb-2" data-id="element-492">
          <div className="flex" data-id="element-493">
            <span className="text-xs font-medium text-neutral-600 min-w-[160px]" data-id="element-494">
              Bank Name:
            </span>
            <span className="text-xs text-neutral-900" data-id="element-495">
              {paymentInstructions.bankName}
            </span>
          </div>
          <div className="flex" data-id="element-496">
            <span className="text-xs font-medium text-neutral-600 min-w-[160px]" data-id="element-497">
              Bank Account No. (SGD):
            </span>
            <span className="text-xs text-neutral-900" data-id="element-498">
              {paymentInstructions.accountNo}
            </span>
          </div>
          <div className="flex" data-id="element-499">
            <span className="text-xs font-medium text-neutral-600 min-w-[160px]" data-id="element-500">
              PayNow UEN:
            </span>
            <span className="text-xs text-neutral-900" data-id="element-501">
              {paymentInstructions.paynowUen}
            </span>
          </div>
        </div>

        <div className="border-t border-neutral-200 pt-2 space-y-0.5 mb-2" data-id="element-502">
          {paymentInstructions.notes.map((note, index) => <p key={index} className="text-[10px] text-neutral-600 leading-snug" data-id="element-503">
              • {note}
            </p>)}
        </div>

        <p className="text-[10px] text-neutral-500 italic pt-2 border-t border-neutral-200" data-id="element-504">
          This is a computer-generated invoice. No signature is required.
        </p>
      </div>
    </div>;
}